/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export interface CustomerCreatePanelProps {
  form: {
    name: string;
    email: string;
    phone: string;
  };
  onUpdateField: (field: "name" | "email" | "phone", value: string) => void;
  error: string;
  isSubmitting: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

export const CustomerCreatePanel = defineComponent<CustomerCreatePanelProps>({
  name: "CustomerCreatePanel",
  props: [
    "form",
    "onUpdateField",
    "error",
    "isSubmitting",
    "onSubmit",
    "onCancel",
  ],
  setup(props) {
    const { t } = useLocalization();

    return () => (
      <div class="space-y-2.5">
        {/* Name */}
        <input
          type="text"
          class="input input-sm input-bordered w-full"
          placeholder={t("reservations.customer_create.name_placeholder")}
          value={props.form.name}
          onInput={(event) =>
            props.onUpdateField(
              "name",
              (event.target as HTMLInputElement).value,
            )
          }
        />

        {/* Email + Phone row */}
        <div class="grid grid-cols-2 gap-2">
          <input
            type="email"
            class="input input-sm input-bordered w-full"
            placeholder={t("reservations.customer_create.email_placeholder")}
            value={props.form.email}
            onInput={(event) =>
              props.onUpdateField(
                "email",
                (event.target as HTMLInputElement).value,
              )
            }
          />
          <input
            type="tel"
            class="input input-sm input-bordered w-full"
            placeholder={t("reservations.customer_create.phone_placeholder")}
            value={props.form.phone}
            onInput={(event) =>
              props.onUpdateField(
                "phone",
                (event.target as HTMLInputElement).value,
              )
            }
          />
        </div>

        {props.error && (
          <div class="text-xs text-error">{props.error}</div>
        )}

        <div class="flex justify-end gap-2">
          <button
            class="btn btn-primary btn-sm"
            onClick={props.onSubmit}
            disabled={props.isSubmitting}
          >
            {props.isSubmitting && (
              <span class="loading loading-spinner loading-xs" />
            )}
            {t("reservations.customer_create.submit_button")}
          </button>
          <button
            class="btn btn-ghost btn-sm"
            onClick={props.onCancel}
            disabled={props.isSubmitting}
          >
            {t("reservations.customer_create.cancel_button")}
          </button>
        </div>
      </div>
    );
  },
});
